import React, { useState, useEffect } from "react";
import { FaHospital } from "react-icons/fa";
import Select from "react-select";

// Options for the department select
const departmentOptions = [
  { value: "Medical", label: "Medical" },
  { value: "Surgical", label: "Surgical" },
  { value: "Pediatrics", label: "Pediatrics" },
  { value: "Orthopedics", label: "Orthopedics" },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Neurology", label: "Neurology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Gastroenterology", label: "Gastroenterology" },
  { value: "Radiology", label: "Radiology" },
  { value: "Emergency", label: "Emergency" },
  { value: "ICU", label: "ICU" },
  { value: "Maternity", label: "Maternity" },
  { value: "Neonatology", label: "Neonatology" },
  { value: "Psychiatry", label: "Psychiatry" },
  { value: "Rehabilitation", label: "Rehabilitation" },
];

// Custom styles for the React Select component
const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "1px solid #d1d5db",
    borderRadius: "0.375rem",
    padding: "0.25rem",
  }),
};

const AddWardModal = ({ isOpen, onClose, onSave }) => {
  const [wardName, setWardName] = useState("");
  const [department, setDepartment] = useState(null);

  // Reset form when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setWardName("");
      setDepartment(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (!wardName.trim() || !department) return;
    onSave({ id: Date.now(), wardName, department: department.value });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-11/12 md:w-1/3">
        <h2 className="text-2xl font-bold mb-4 flex items-center">
          <FaHospital className="mr-2 text-blue-600" /> Add New Ward
        </h2>
        <input
          type="text"
          placeholder="Ward Name"
          value={wardName}
          onChange={(e) => setWardName(e.target.value)}
          className="w-full border p-2 rounded mb-4"
        />
        <Select
          placeholder="Select Department"
          value={department}
          onChange={setDepartment}
          options={departmentOptions}
          styles={customStyles}
          className="mb-4"
        />
        <div className="flex justify-end space-x-3">
          <button
            onClick={handleSave}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddWardModal;
